
define('text!templates/modules/calendar/animated-session/animation/rename/animation-rename-modal.html',[],function () { return '<form id="animation-rename-form"></form>\n';});

